// Modul Codebooks – i18n manifest (sdílené selektory číselníků)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'codebooks';

export const codebooksI18nManifest: SliceI18nManifest = {
  owner: 'modules/codebooks',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
